import React from 'react';
export function Footer() {
  return <footer className="w-full bg-night-deep" data-id="element-134" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl px-5 py-12 text-center" data-id="element-135" data-mp="3gezev8fo7z39">
        <h3 className="font-display text-2xl text-coral" data-id="element-136" data-mp="3ghc5e9zhvhrx">Acro Yoga Class Ready</h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-sand/70" data-id="element-137" data-mp="32pfc42m3b1ty">
          The 3-Lane Spot Plan — one plan, three lanes, every level in the
          room.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2.5 text-[13px] text-sand/70" data-id="element-138" data-mp="3ug3etj3ewf9q">
          <a href="mailto:[SUPPORT_EMAIL]" className="hover:text-sand hover:underline" data-id="element-139" data-mp="37o74x94c1ef">
            [SUPPORT_EMAIL]
          </a>
          <a href="[INSTAGRAM_URL]" className="hover:text-sand hover:underline" data-id="element-140" data-mp="3le2kov3h69ca">
            [@handle]
          </a>
          <a href="[SITE_URL]" className="hover:text-sand hover:underline" data-id="element-141" data-mp="3qf9suv9j5ajh">
            [www.site.com]
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-sand/15 pt-5 text-xs leading-relaxed text-sand/50" data-id="element-142" data-mp="2eyt8qon165qa">
          Material for teachers and facilitators. Not a replacement for
          in-person certified training. Practise on mats, with the consent of
          every participant and an attentive spotter. Fly-lane skills require
          prior experience. For pain, injury, pregnancy or any health
          condition, refer to a health professional. Independent resource; not
          affiliated with or endorsed by any acro yoga school, lineage or
          organization. &copy; Acro Yoga Class Ready 2026 — All rights
          reserved.
        </p>
      </div>
    </footer>;
}